var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Anchor, Container, Image, Separator } from 'telia-front-react';
import { observer } from 'mobx-react';
import { injectStores } from '../util/StoresUtil';
import React, { Component } from 'react';
let BannerContainer = class BannerContainer extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "bannerStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    componentDidMount() {
        this.bannerStore.fetchBanner(this.props.slug);
    }
    render() {
        const { slug } = this.props;
        const banner = this.bannerStore.getBanner(slug);
        return (React.createElement(React.Fragment, null, banner && (React.createElement(Container, null,
            React.createElement(Separator, { spacing: "medium-plus", color: "invisible" }),
            React.createElement(Anchor, { url: banner.href },
                React.createElement(Image, { srcset: this.bannerStore.getMobileSrcSetForBanner(slug), alt: banner.alt, align: "center", sources: [
                        {
                            minWidth: '1024px',
                            srcset: this.bannerStore.getDesktopSrcSetForBanner(slug)
                        }
                    ] }))))));
    }
};
BannerContainer = __decorate([
    injectStores,
    observer
], BannerContainer);
export default BannerContainer;
